<template lang="pug">
.loader.section-transition-item(aria-label="Loading" tabindex="0")
  .loader-wrapper
    span
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped lang="scss">
  
</style>